import React, { useState, useRef, useEffect } from 'react';
import CustomSVGs from '../customSVGs/CustomSVGs';
import {
  arrowHeadRightLightSVG,
  funnelSVG,
  search2SVG,
  tickSVG,
} from '../../lib/allCustomSVGs';
import '../../styles/boxes/filterBox.scss';

interface FilterBoxProps {
  filterOptions: string[];
  onSearchChange?: (value: string) => void;
  onFilterChange?: (selected: string) => void;
  initialFilter?: string;
  placeholder?: string;
  extraClassName?: string;
}

const FilterBox: React.FC<FilterBoxProps> = ({
  filterOptions,
  onSearchChange,
  onFilterChange,
  initialFilter = '',
  placeholder = 'Search...',
  extraClassName = '',
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(
    initialFilter || filterOptions[0]
  );
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleOutsideClick = (e: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(e.target as Node)
    ) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  const handleFilterSelect = (option: string) => {
    setSelectedFilter(option);
    onFilterChange?.(option);
    setDropdownOpen(false);
  };

  return (
    <div className={`filterBox ${extraClassName}`}>
      <div className='filterBox__input'>
        <CustomSVGs svg={search2SVG} />
        <input
          type='text'
          placeholder={placeholder}
          className='filterBox__input--field'
          onChange={(e) => onSearchChange?.(e.target.value)}
        />
      </div>

      <div
        className='filterBox__filter'
        ref={dropdownRef}
        onClick={() => setDropdownOpen(!dropdownOpen)}
      >
        <CustomSVGs className='filterBox__filter--icon' svg={funnelSVG} />
        <div className='filterBox__filter--text'>{selectedFilter}</div>
        <CustomSVGs
          className='filterBox__filter--arrow'
          svg={arrowHeadRightLightSVG}
        />

        {dropdownOpen && (
          <div className='filterBox__filter--dropdown'>
            {filterOptions.map((option) => (
              <div
                key={option}
                className='filterBox__filter--dropdown-item'
                onClick={(e) => {
                  e.stopPropagation(); // prevent dropdown toggle
                  handleFilterSelect(option);
                }}
              >
                {selectedFilter === option && <CustomSVGs svg={tickSVG} />}
                {selectedFilter !== option && (
                  <span style={{ width: '1.6rem' }} />
                )}{' '}
                {/* spacer */}
                <span>{option}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FilterBox;
